module.exports = __webpack_public_path__ + "static/media/dummies_1.616515b1.jpg";